<div class="widget" >
  <label [translate]="'widgets.settings.labelLanguage'">Language</label>
  <div class="dropdown">
    <select class="dropdown__select" [ngModel]="this.translate.currentLang" (change)="changeLanguage($event)">
      <option class="dropdown__item" *ngFor="let lang of languageOptions" [value]="lang">
        {{('lang.' + lang) | translate}}
      </option>
    </select>
    <div class="dropdown__icon">
      <i class="material-icons">keyboard_arrow_down</i>
    </div>
  </div>

  <!-- Mark as Unseen Timeout -->
  <label>Last Updated Red Threshold</label>
  <div class="mark-as-unseen-timeout-container">
    <div class="timeout-field">
      <label>Days</label>
      <input type="number" [(ngModel)]="timeoutDays" min="0">
    </div>
    <div class="timeout-field">
      <label>Hours</label>
      <input type="number" [(ngModel)]="timeoutHours" min="0">
    </div>
    <div class="timeout-field">
      <label>Minutes</label>
      <input type="number" [(ngModel)]="timeoutMinutes" min="0">
    </div>
  </div>
  <button mat-raised-button color="primary" (click)="onSaveThreshold()">Save</button>
</div>
